import { isEmpty } from "lodash";

import { InsightFamilyNameToLabelMap } from "../constants/filters";
import type { RefreshCadence } from "../types/insightFamilyRefreshCadence";

import {
    DateFormat,
    formatDate,
    isValidDateString,
    Timezone,
} from "./date.utils";

export const formatFamilyName = (
    familyName: string | undefined,
): string | undefined => {
    return familyName && InsightFamilyNameToLabelMap[familyName]
        ? InsightFamilyNameToLabelMap[familyName]
        : undefined;
};

export const formatObjectives = (
    objectives: string[] | undefined,
): string | undefined => {
    return !isEmpty(objectives) ? objectives?.join(", ") : undefined;
};

export const DATE_FORMAT_ERROR_MESSAGE = "(Unable to format provided date)";

export const formatStartEndDate = (
    startDate: string | undefined,
    endDate: string | undefined,
): string | undefined => {
    if (!isEmpty(startDate) && !isEmpty(endDate)) {
        // startDate & endDate provided as date string formatted as "YYYY-mm-dd"
        // When parsing date without times, it is implied to be UTC
        // To avoid timezone related issues (showing dates as preceding date, etc), date is formatted to be in UTC
        return isValidDateString(startDate!) && isValidDateString(endDate!)
            ? `${formatDate(startDate, DateFormat.LONG_DATE_FORMAT, Timezone.UTC)} to ${formatDate(endDate, DateFormat.LONG_DATE_FORMAT, Timezone.UTC)}`
            : `${startDate} to ${endDate} ${DATE_FORMAT_ERROR_MESSAGE}`;
    } else return undefined;
};

export const formatCadence = (cadence: RefreshCadence): string => {
    return cadence.replace(/_/g, " ");
};
